
import React from 'react';

const reasons = [
  {
    icon: 'ri-scales-3-line',
    title: 'Independent & Unbiased',
    description:
      'We work for you, not insurance companies. As an independent broker, we compare private health insurance plans from 50+ carriers to find your best option in Houston.',
  },
  {
    icon: 'ri-time-line',
    title: 'Available 24/7',
    description:
      "Health insurance questions don’t follow business hours. Our Houston team is available around the clock — call, email, or visit us anytime day or night.",
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Free Consultations',
    description:
      'Our expert advice costs you nothing. We are compensated by insurance carriers, so you get professional health insurance guidance at zero cost.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Local Houston Expertise',
    description:
      'We know the Houston healthcare market inside and out. From the Texas Medical Center to community clinics, we match you with plans that include your preferred providers.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Fast Coverage',
    description:
      "Need private health insurance quickly? Some plans can start as soon as the next day. We streamline the enrollment process so you're covered without delay.",
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Ongoing Support',
    description:
      "Our relationship doesn’t end at enrollment. We help Houston clients with claims, renewals, and plan changes throughout the year — always just a call away.",
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="lg:sticky lg:top-32">
            <span className="inline-flex items-center gap-2 text-brand-600 text-sm font-semibold tracking-wider uppercase mb-3">
              <span className="w-8 h-[2px] bg-brand-500"></span>
              Why Choose Us
            </span>
            <h4 className="text-4xl font-display font-bold text-navy-900 mb-6 leading-tight">
              <a href="#why-us">
                Why Houston Trusts Data Health Insurance Consultants
              </a>
            </h4>
            <p className="text-navy-500 text-base leading-relaxed mb-8">
              Choosing the right private health insurance broker in Houston makes
              all the difference. Here&apos;s why hundreds of individuals and
              companies trust us with their health coverage needs.
            </p>
            <div className="relative w-full h-[340px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/f4ab4a326c3b3241c1ebd040137c350f.jpg"
                alt="Houston families trust Data Health Insurance Consultants for private health insurance"
                title="Trusted private health insurance broker Houston TX"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="space-y-5">
            {reasons.map((reason) => (
              <article
                key={reason.title}
                className="bg-navy-50/50 rounded-xl p-6 hover:bg-brand-50/50 hover:border-brand-200 transition-all duration-300 border border-transparent group cursor-pointer"
              >
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-brand-100 flex items-center justify-center flex-shrink-0 group-hover:bg-brand-500 transition-colors duration-300">
                    <i
                      className={`${reason.icon} text-xl text-brand-600 group-hover:text-white transition-colors duration-300`}
                    ></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-display font-bold text-navy-900 mb-2">
                      {reason.title}
                    </h3>
                    <p className="text-navy-500 text-sm leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
